<template>
  <div class="vs-con-loading__container">

    <div class="vx-row">

      <div class="vx-col w-full">

        <div class="vx-row align-center mb-3">
          <div class="vx-col sm:w-3/12 w-full">
            <strong v-text="$t('business_person')"></strong>
          </div>
          <div class="vx-col sm:w-9/12 w-full">
<!--            <select v-model="messageFormData.assigned_agent_id" class="vs-inputx vs-input&#45;&#45;input normal hasValue">-->
<!--              <option value="" v-text="$t('please_select')"></option>-->
<!--              <option v-for="(option, key) in extensions" :key="'extensions_' + key" :value="key">{{ option }}</option>-->
<!--            </select>-->
            <v-select :options="extensions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="messageFormData.assigned_agent_id" class="md:mb-0" />
            <validation-error :model-error="messageFormErrors.assigned_agent_id"></validation-error>
          </div>
        </div>

        <div class="vx-row align-center mb-3">
          <div class="vx-col sm:w-3/12 w-full">
            <strong v-text="$t('consulting_title')"></strong>
          </div>
          <div class="vx-col sm:w-9/12 w-full">
            <vs-input v-model="messageFormData.title" class="w-full"/>
            <validation-error :model-error="messageFormErrors.title"></validation-error>
          </div>
        </div>

        <div class="vx-row align-center mb-3">
          <div class="vx-col sm:w-3/12 w-full">
            <strong v-text="$t('consultation_contents')"></strong>
          </div>
          <div class="vx-col sm:w-9/12 w-full">
            <vs-textarea class="mb-0" v-model="messageFormData.content" />
            <validation-error :model-error="messageFormErrors.content"></validation-error>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>

import MessageManagement from '@/models/MessageManagement'
import { EventBus } from '@/../eventbus.js'
import announcementSocket from '@/libs/sockets/announcements'

export default {
  name: 'Shared.MessageManagement.SendMessage',
  props: {
    extensions: {
      type: [Object, Array],
      required: true
    }
  },
  data () {
    return {
      messageFormData: {
        assigned_agent_id: '',
        title: '',
        content: ''
      },
      messageFormErrors: {}
    }
  },
  computed: {
    server () {
      return this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.servers : {}
    }
  },
  mounted () {
    EventBus.$on('initResetSendMessageFormData', this.initResetSendMessageFormData)
    EventBus.$on('initSendMessage', this.sendMessage)
    announcementSocket.setNode(this.server)
  },
  methods: {
    async initResetSendMessageFormData () {
      this.messageFormData = {
        assigned_agent_id: '',
        title: '',
        content: ''
      }
      this.messageFormErrors = {}
    },
    async sendMessage () {

      this.$vs.loading({background: 'primary', color: '#fff', container: '#sendMessageButton', scale: 0.45})

      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)

          const response = await MessageManagement.store(this.messageFormData)
          announcementSocket.getSocket().emit('init_message_management_count')

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.$store.dispatch('setIsFormInProgress', false)

          this.initResetSendMessageFormData()
          this.$emit('sendMessageSuccess')

        }
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.messageFormErrors = errors.validationErrors
        this.$store.dispatch('setIsFormInProgress', false)
      }

      this.$vs.loading.close('#sendMessageButton > .con-vs-loading')
    }
  }
}
</script>

<style lang="scss">
  #sendMessageButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
